import type {GeneratedImageEvent} from '@AiChat/callbacks/ai-chat-callbacks.types';
import type {ChatMessage, ChatMessageModelImagePart, ChatMessageTextPart, ImageStreamEvent} from '@Components/ai-chat-window/ai-chat-window.types';
import {ChatMessagePartType} from '@Components/ai-chat-window/ai-chat-window.types';

export function toGeneratedImageEvent(event: ImageStreamEvent): GeneratedImageEvent | null {
  const imageParts = getGeneratedImageParts(event);

  if (imageParts.length === 0) {
    return null;
  }

  const firstPart = imageParts[0];

  return {
    chatId: event.idAiChat,
    messageId: event.message.messageId ?? null,
    hashedIds: imageParts.map((part) => part.hashedId).filter((hashedId) => hashedId !== ''),
    width: firstPart.width,
    height: firstPart.height,
    isFirstGeneration: event.showFirstImageGenerationDelight,
  };
}

export function getFailedMessageText(message: ChatMessage): string {
  const textParts = message.parts.filter((part): part is ChatMessageTextPart => {
    return part.type === ChatMessagePartType.TEXT;
  });

  return textParts.map((part) => part.text).join(' ');
}

function getGeneratedImageParts(event: ImageStreamEvent): ChatMessageModelImagePart[] {
  return event.message.parts.filter((part): part is ChatMessageModelImagePart => {
    return part.type === ChatMessagePartType.MODEL_GENERATED_IMAGE && !part.isSkeletonPlaceholder;
  });
}
